const defaultAcceptedFileTypes: FileType[] = [
  'DOCX',
  'EML',
  'HTML',
  'INVALID_FILE_TYPE',
  'JPG',
  'MBOX',
  'MP3',
  'MP4',
  'MSG',
  'PDF',
  'PNG',
  'PPTX',
  'TIFF',
  'WAV',
  'XLSX',
]

export default defaultAcceptedFileTypes
